import axios from "axios";

export function updatePass(data) {
    return axios({
        url: '/user/SysUserWsg/updatePassword?',
        method: 'post',
        data: data,
        headers:{
            'Authorization': 'Bearer '+sessionStorage.getItem("access_token")
        }
    })
}